import React, { useState, useEffect, useRef } from "react";
import { TextField, Box } from "@mui/material";
import { APIProvider, useMapsLibrary } from "@vis.gl/react-google-maps";
import { mapAPIKey } from "../config/config";

// Move libraries array outside component to prevent re-renders
const GOOGLE_MAPS_LIBRARIES = ['places'];

const Autogooglecomplete = ({ setNodeData, errors, nodeData }) => {
  const [selectedPlace, setSelectedPlace] = useState(null);

  useEffect(() => {
    if (selectedPlace) {
      const fetchPlaceData = () => {
        if (!selectedPlace.address_components) {
          setTimeout(fetchPlaceData, 100);
          return;
        }
        // Extract data after ensuring it is available
        // const formattedAddress = selectedPlace.formatted_address;
        // const addressParts = formattedAddress.split(', ');

        // const countryName = addressParts[addressParts.length - 1];

        const addressComponents = selectedPlace.address_components;
        const countryComponent = addressComponents.find(component =>
          component.types.includes("country")
        );
        const countryCode = countryComponent ? countryComponent.short_name : '';

        //// console.log("Country Code:", countryCode);

        setNodeData((prevData) => ({
          ...prevData,
          location: {
            name: selectedPlace.name,
            address: selectedPlace.formatted_address,
            lat: selectedPlace.geometry.location.lat(),
            lng: selectedPlace.geometry.location.lng(),
            countryName: countryCode,
            // countryCode: countryCode
          }
        }));
      };
      fetchPlaceData();
    }
  }, [selectedPlace, setNodeData]);

  // APIProvider will automatically detect and reuse Google Maps script if already loaded by LoadScript
  return (
    <APIProvider
      apiKey={mapAPIKey}
      libraries={GOOGLE_MAPS_LIBRARIES}
      solutionChannel="GMP_devsite_samples_v3_rgmautocomplete"
    >
      <Box sx={{ position: 'relative', zIndex: 1300 }}>
        <PlaceAutocomplete onPlaceSelect={setSelectedPlace} errors={errors} nodeData={nodeData} />
      </Box>
    </APIProvider>
  );
};

const PlaceAutocomplete = ({ onPlaceSelect, errors, nodeData }) => {
  const [placeAutocomplete, setPlaceAutocomplete] = useState(null);
  const inputRef = useRef(null);
  const places = useMapsLibrary("places");

  useEffect(() => {
    if (!places || !inputRef.current) return;

    const options = {
      fields: ["geometry", "name", "formatted_address", "address_components"]
    };

    setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));
  }, [places]);

  useEffect(() => {
    if (!placeAutocomplete) return;
    placeAutocomplete.addListener("place_changed", () => {
      onPlaceSelect(placeAutocomplete.getPlace());
    });
  }, [onPlaceSelect, placeAutocomplete]);

  return (
    <Box className="autocomplete-container">
      <TextField
        inputRef={inputRef}
        label={nodeData?.location?.address || 'Enter location'}
        variant="outlined"
        fullWidth
        size="small"
        error={Boolean(errors.general?.location)}
        helperText={errors.general?.location || ''}
      />
    </Box>
  );
};

export default Autogooglecomplete;

